<mat-chip-list #chipList>
  <mat-chip
    *ngFor="let value of values"
    selectable="true"
    removable="true"
    (removed)="remove(value)"
  >
    {{ value }}
    <studio-icon matChipRemove name="close" size="10"></studio-icon>
  </mat-chip>
  <input
    #input
    [id]="uniqueId"
    [formControl]="inputCtrl"
    [placeholder]="placeholder"
    [matChipInputFor]="chipList"
    [matAutocomplete]="autocompleteList"
    [matAutocompleteDisabled]="!autocomplete"
    [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
    (matChipInputTokenEnd)="add($event)"
    matChipInputAddOnBlur="false"
    (blur)="onTouch($event)"
  />
</mat-chip-list>
<mat-autocomplete
  #autocompleteList="matAutocomplete"
  class="chip-list-autocomplete"
  (optionSelected)="optionSelected($event)"
  (optionActivated)="optionActivated($event)"
>
  <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option">{{
    option
  }}</mat-option>
</mat-autocomplete>
